import React from "react";

const About = () => {
  return (
    <div>
      <section className="section about-section">
        <h1 className="section-title">About Us</h1>
        <p>
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Saepe
          eveniet aliquid mollitia vel veniam. Ea pariatur maiores est sunt
          asperiores!
        </p>
      </section>
    </div>
  );
};

export default About;
